import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollArea", "leftArrow", "rightArrow"]

  connect() {
    this._onScroll = () => this._updateArrows()
    this.scrollAreaTarget.addEventListener("scroll", this._onScroll)
    this._resizeObserver = new ResizeObserver(() => this._updateArrows())
    this._resizeObserver.observe(this.scrollAreaTarget)
    this._updateArrows()
  }

  disconnect() {
    this.scrollAreaTarget.removeEventListener("scroll", this._onScroll)
    this._resizeObserver?.disconnect()
  }

  scrollLeft() {
    this.scrollAreaTarget.scrollBy({ left: -200, behavior: "smooth" })
  }

  scrollRight() {
    this.scrollAreaTarget.scrollBy({ left: 200, behavior: "smooth" })
  }

  _updateArrows() {
    const { scrollLeft, scrollWidth, clientWidth } = this.scrollAreaTarget
    const hasOverflow = scrollWidth > clientWidth

    if (this.hasLeftArrowTarget) {
      this.leftArrowTarget.classList.toggle("hidden", !hasOverflow || scrollLeft <= 0)
    }

    if (this.hasRightArrowTarget) {
      this.rightArrowTarget.classList.toggle("hidden", !hasOverflow || scrollLeft >= scrollWidth - clientWidth - 1)
    }
  }
}
